import { ClipboardCheckIcon, FolderOpenIcon, RulerIcon, SigmaIcon, TargetIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Banco de 150 Actividades y Prácticas de Topografía',
    description:
      'Actividades de aula, ejercicios de cálculo, interpretación de planos, análisis de mediciones, prácticas simuladas y propuestas de campo organizadas por nivel de dificultad.',
    benefit: 'Materiales ya pensados para el aula: ahorrá horas en cada trimestre.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Kit de Evaluación Topográfica — 60 Instrumentos',
    description:
      'Evaluaciones diagnósticas, cuestionarios, trabajos prácticos, consignas de investigación, ejercicios integradores, rúbricas, listas de cotejo y respuestas orientativas.',
    benefit: 'Nunca más construyas un examen desde cero bajo presión.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: '100 Problemas y Cálculos Topográficos Resueltos',
    description:
      'Ejercicios de distancias, escalas, coordenadas, ángulos, pendientes, nivelación, poligonales, superficies y volúmenes. Cada uno acompañado por procedimientos explicados paso a paso.',
    benefit: 'Tus alumnos aprenden viendo cómo se resuelve realmente.',
    value: 'USD 14',
    icon: SigmaIcon,
  },
  {
    number: '04',
    title: 'Guía Visual de Instrumentos y Operaciones de Campo',
    description:
      'Material ilustrado para reconocer equipos, comprender su funcionamiento, analizar procedimientos de medición, organizar campañas y enseñar buenas prácticas de seguridad.',
    benefit: 'Proyectala en clase y tus alumnos entienden de inmediato.',
    value: 'USD 14',
    icon: RulerIcon,
  },
  {
    number: '05',
    title: '30 Proyectos Integradores de Topografía para el Aula',
    description:
      'Propuestas contextualizadas en terrenos rurales, espacios urbanos, caminos, obras, minería, agricultura y ordenamiento territorial. Listas para consultar, imprimir y adaptar.',
    benefit: 'Tus alumnos cierran el año con proyectos reales en sus territorios.',
    value: 'USD 14',
    icon: TargetIcon,
    wide: true,
  },
];
